<template>
  <BModal
    id="image-upload-modal"
    ref="imageUploadModal"
    v-model="isVisible"
    size="lg"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    @hidden="onModalHidden"
  >
    <template #header></template>
    <template #footer></template>
    <BOverlay :show="overlayShow" rounded="sm">
      <!-- モーダル閉じるxボタン -->
      <div class="text-end">
        <BButton @click="hideModal()" aria-label="Close" class="btn-close text-reset" v-if="attendeeType === this.consts.attendeeType.florist && bodyName !== 'uploadImageComplete'"></BButton>
      </div>

      <!-- 画像受け取り種別選択画面 -->
      <template v-if="bodyName === 'index'">
        <div class="text-center mt-2 mb-3">
          <span>画像アップロードをおこなう端末の形式を選択</span><br />
        </div>
        <div class="row">
          <div class="col text-center">
            <button class="btn main-color main-color-hover text-light" @click="receiveFromOtherTerminal()">QRコード表示</button>
          </div>
          <div class="col text-center">
            <button class="btn main-color main-color-hover text-light" @click="receiveFromSameTerminal()">お客様操作端末</button>
          </div>
          <div class="col text-center">
            <button class="btn main-color main-color-hover text-light" @click="floristUploadTerminal()">フローリスト操作端末</button>
          </div>
        </div>
      </template>

      <!-- 画像選択画面 -->
      <template v-if="bodyName === 'selectImage'">
        <div class="text-center mt-1 mb-3">
          <span>「画像を選択」ボタンを押して</span><br />
          <span>アップロードする画像を選択してください。</span>
        </div>

        <div class="text-center mb-2">
          <input type="file" ref="uploadImageInput" @change="uploadFile('customer')" class="d-none" multiple="multiple">
          <button class="btn main-color text-light" :class="{'main-color-hover' : attendeeType === consts.attendeeType.customer}" :disabled="customerType === consts.customerType.guest" @click="uploadImageBtnClick('customer')">画像を選択</button>
        </div>
        <!-- localImageUrlに値が入ったら表示 -->
        <div v-if="localImageUrl.length > 0">
          <div class="w-75 m-auto">
            <!-- カスタマーは画像を表示 -->
            <div v-if="attendeeType === consts.attendeeType.customer" style="max-height: 300px; overflow: scroll;">
              <template v-for="(url, index) in localImageUrl" :key="index">
                <img :src="url" width="100%" class="mt-1" style="display: none">
              </template>
              <div class="customer-upload-wait-image">
                <p>{{resizeImageCount}}枚選択中</p>
              </div>
            </div>
            <!-- フローリストは文字列を表示 -->
            <div class="florist-upload-wait-image" v-if="attendeeType === consts.attendeeType.florist">
              <p>お客様が画像を選択中です</p>
            </div>
          </div>
          <div class="text-center mt-4">
            <button class="btn main-button-color text-light" @click="sendUploadImage()" :disabled="attendeeType === consts.attendeeType.florist || uploadBtnDisabled">アップロード</button>
          </div>
        </div>
        <!-- localImageUrlに値がない場合は空白を表示 -->
        <div v-else>
          <div style="min-height: 300px;"></div>
        </div>
      </template>

      <!-- フローリスト画像選択画面 -->
      <template v-if="bodyName === 'floristSelectImage'">
        <div class="text-center mt-1 mb-3">
          <span>「画像を選択」ボタンを押して</span><br />
          <span>アップロードする画像を選択してください。</span>
        </div>

        <div class="text-center mb-2">
          <input type="file" ref="uploadImageInput" @change="uploadFile('florist')" class="d-none" multiple="multiple">
          <button class="btn main-color text-light" :class="{'main-color-hover' : attendeeType === consts.attendeeType.florist}" @click="uploadImageBtnClick('florist')">画像を選択</button>
        </div>
        <!-- localImageUrlに値が入ったら表示 -->
        <div v-if="localImageUrl.length > 0">
          <div class="w-75 m-auto">
            <!-- フローリストは画像を表示 -->
            <div v-if="attendeeType === consts.attendeeType.florist" style="max-height: 300px; overflow: scroll;">
              <template v-for="(url, index) in localImageUrl" :key="index">
                <img :src="url" width="100%" class="mt-1" style="display: none">
              </template>
              <div class="customer-upload-wait-image">
                <p>{{resizeImageCount}}枚選択中</p>
              </div>
            </div>
            <!-- カスタマーは文字列を表示 -->
            <div class="florist-upload-wait-image" v-if="attendeeType === consts.attendeeType.customer">
              <p>フローリストが画像を選択中です</p>
            </div>
          </div>
          <div class="text-center mt-4">
            <button class="btn main-button-color text-light" @click="sendUploadImage()" :disabled="attendeeType === consts.attendeeType.customer || uploadBtnDisabled">アップロード</button>
          </div>
        </div>
        <!-- localImageUrlに値がない場合は空白を表示 -->
        <div v-else>
          <div style="min-height: 300px;"></div>
        </div>
      </template>

      <!-- 画像アップロード完了画面 -->
      <template v-if="bodyName === 'uploadImageComplete'">
        <div class="text-center mt-4 mb-5">
          <span v-if="attendeeType === consts.attendeeType.customer || floristUploaded">画像がアップロードされました。</span>
          <span v-else>お客様ご持参の画像がアップロードされました。</span>
        </div>
        <div class="text-center mt-2" v-if="attendeeType === consts.attendeeType.florist">
          <button class="btn main-button-color text-light px-5" @click="uploadCompleteOK()">OK</button>
        </div>
        <div class="text-center mt-2" v-else>
          &nbsp;
        </div>
      </template>

      <!-- QR画像表示画面 -->
      <template v-if="bodyName === 'qrImageShow'">
        <div class="text-center mt-2 mb-3">
          <span>QRコードを読み込んで</span><br />
          <span>画像をアップロードしてください。</span>
        </div>
        <div class="text-center">
          <BOverlay :show="qrImageOverlayShow" rounded="sm">
            <VueQrcode
              :value="qrImageUrl"
              :options="{
                errorCorrectionLevel: 'M',
                maskPattern: 0,
                margin: 10,
                scale: 2,
                width: 300,
                color: {
                  dark: '#000000FF',
                  light: '#FFFFFFFF'
                }
              }"
              tag="img"
              v-if="qrImageUrl"
            />
            <div v-else>
              <p>QR画像情報の取得に失敗しました。</p>
            </div>
          </BOverlay>
        </div>
      </template>
    </BOverlay>
    <CommonModal ref="commonModal" />
    <CommonFunction ref="commonFunction" />
  </BModal>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { BModal, BOverlay, BButton } from 'bootstrap-vue-next'
import LoginInfoModel from '@/models/LoginInfoModel'
import CommonModal from '@/components/CommonModal'
import CommonFunction from '@/components/CommonFunction'
import BringImageModel from '@/models/BringImageModel'
import CookieInfoModel from '@/models/CookieInfoModel'

export default {
  name: 'ImageUploadModal',
  components: {
    VueQrcode,
    BModal,
    BOverlay,
    BButton,
    LoginInfoModel,
    BringImageModel,
    CommonFunction,
    CommonModal
  },
  props: {
    cookieProjectNumber: {
      type: String,
      default: ''
    }
  },
  emits: ['signalingModalChangeEvent', 'cookieProjectNumberCheck'],
  data () {
    return {
      isVisible: false,
      bodyName: 'index',
      localImageUrl: [],
      overlayShow: false,
      qrImageOverlayShow: false,
      attendeeType: '',
      qrImageUrl: '',
      resizeImages: [],
      uploadBtnDisabled: true,
      resizeImageCount: 0,
      resizeCompleteCount: 0,
      floristUploaded: false,
      customerType: sessionStorage.customerType,
      consts: {
        attendeeType: {
          "florist": "01",
          "customer": "02"
        },
        customerType: {
          guest: 'guest'
        },
        maxUploadBringImageCount: 20,
        errorMsg: {
          otherCookieProjectNumber: 'セッションが切れました。'
        }
      }
    }
  },
  methods: {
    showModal (attendeeType, bodyName = 'index') {
      console.log('ImageUploadModal.showModal called with:', { attendeeType, bodyName })
      console.log('Expected attendeeType values:', Object.values(this.consts.attendeeType))
      console.log('Received attendeeType:', attendeeType)
      console.log('Type of received attendeeType:', typeof attendeeType)
      console.log('Consts check:', this.consts.attendeeType && Object.values(this.consts.attendeeType).includes(attendeeType))
      this.uploadBtnDisabled = true
      if (this.consts.attendeeType && Object.values(this.consts.attendeeType).includes(attendeeType)) {
        this.attendeeType = attendeeType
        this.changeBody(bodyName)
        this.isVisible = true
        console.log('Modal should now be visible')
        return true
      } else {
        console.error('Validation failed - attendeeType not found in allowed values')
        return false
      }
    },
    hideModal () {
      this.localImageUrl = []
      this.isVisible = false
      if (this.attendeeType === this.consts.attendeeType.florist) {
        this.$emit('signalingModalChangeEvent', 'modalUploadHide')
      }
      if (this.$refs.uploadImageInput) {
        this.$refs.uploadImageInput.value = ''
      }
    },
    onModalHidden () {
      this.resetModal()
    },
    resetModal () {
      this.localImageUrl = []
      this.bodyName = 'index'
      this.resizeImages = []
      this.uploadBtnDisabled = true
      this.resizeImageCount = 0
      this.resizeCompleteCount = 0
      this.floristUploaded = false
    },
    changeBody (bodyName) {
      this.bodyName = bodyName
    },
    receiveFromSameTerminal () {
      this.bodyName = 'selectImage'
      this.$emit('signalingModalChangeEvent', 'modalSelectImage')
    },
    floristUploadTerminal () {
      this.bodyName = 'floristSelectImage'
      this.$emit('signalingModalChangeEvent', 'floristModalSelectImage')
    },
    receiveFromOtherTerminal: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      console.log(cookieProjectNumberCheckResult)
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      const uri = new URL(window.location.href)
      const baseURL = uri.origin + '/customer/upload_image?'
      this.qrImageOverlayShow = true
      const resData = await LoginInfoModel.apiSetStore(this.$bvModal, () => {
        this.qrImageOverlayShow = false
      })

      this.bodyName = 'qrImageShow'
      this.$emit('signalingModalChangeEvent', 'modalQrImageShow')
      if (resData.projectNumber && resData.hashPassword) {
        const targetUrl = baseURL + 'projectNumber=' + resData.projectNumber + '&token=' + resData.hashPassword
        this.setQrImageUrl(targetUrl)
        this.$emit('signalingModalChangeEvent', 'modalQrImageURL', { url: targetUrl })
      }
    },
    uploadFile (possibleType) {
      if (this.attendeeType === this.consts.attendeeType[possibleType]) {
        if (this.$refs.uploadImageInput.files.length === 0) {
          this.$refs.commonModal.msgBoxOk('画像を選択してください')
          this.imageIni()
          return false
        }
        const fileCount = this.$refs.uploadImageInput.files.length

        // 20枚以上の場合はバリデーションエラー
        if (fileCount > this.consts.maxUploadBringImageCount) {
          this.$refs.commonModal.msgBoxOk('登録可能なファイルは' + this.consts.maxUploadBringImageCount + '枚のみです。')
          this.imageIni()
          return false
        }

        this.localImageUrl = []
        this.uploadBtnDisabled = true
        for (let i = 0; i < fileCount; i++) {
          let file = this.$refs.uploadImageInput.files[i]
          const extend = file.name.match(/[^.]+$/)[0]
          // 拡張子バリデーション
          if (['PNG', 'png', 'JPG', 'JPEG', 'jpg', 'jpeg', 'GIF', 'gif'].includes(extend) === false) {
            this.$refs.commonModal.msgBoxOk('登録可能なファイル形式はjpeg・jpg・png・gifのみです。')
            this.uploadBtnDisabled = true
            return false
          }
          this.beforeResizeImage(file, fileCount, this, i)
        }
        this.resizeImageCount = fileCount
        this.$emit('signalingModalChangeEvent', 'modalUploadImage')
        if (possibleType === 'florist') {
          this.floristUploaded = true
        }
      }
    },
    gcd (x, y) {
      if (y === 0) {
        return x
      }
      return this.gcd(y, x % y)
    },
    resizeImage (imageData, num, canvasWidth, canvasHeight) {
      const canvas = document.createElement('canvas')
      canvas.width = canvasWidth
      canvas.height = canvasHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(imageData, 0, 0, canvasWidth, canvasHeight)

      this.resizeImages[num] = canvas.toDataURL('image/jpeg')

      canvas.height = 0
      canvas.width = 0
      canvas.remove()
      this.resizeCompleteCount++
    },
    setQrImageUrl (url) {
      this.qrImageUrl = url
    },
    floristUploadFile () {
      this.localImageUrl = true
    },
    customerUploadFile () {
      this.localImageUrl = true
    },
    sendUploadImage: async function () {
      if (this.attendeeType === this.consts.attendeeType.florist) {
        // フローリストのみcookieの打合せIDが変化しているかチェック
        let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
        console.log(cookieProjectNumberCheckResult)
        if (!cookieProjectNumberCheckResult) {
          this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
          return
        }
      }
      this.overlayShow = true

      if (this.resizeImages.length === 0) {
        this.$refs.commonModal.msgBoxOk('サーバーへのアップロードに失敗しました。最初からやり直してください。')
        this.imageIni()
        return false
      }

      let fileSizeSum = 0
      let reqData = []
      reqData.push({ bringImages: [], totalBringImages: this.resizeImages.length })
      let reqDataNo = 0
      for (let key = 0; key < this.resizeImages.length; key++) {
        const base64FileStr = this.resizeImages[key]
        const file = this.$refs.uploadImageInput.files[key]

        if (!file || !file.name) {
          return false
        }

        if (!base64FileStr) {
          return false
        }

        // 画像アップロード用データ
        const imageData = {
          bringImage: base64FileStr.replace(/^.*,/, ''),
          fileName: file.name
        }
        if (imageData.bringImage.length > 4000000) {
          this.$refs.commonModal.msgBoxOk('アップロード可能なファイルサイズ上限は4MBです。')
          this.imageIni()
          return false
        }
        fileSizeSum += imageData.bringImage.length

        // 画像を4M以上送付しようとしているのであれば、4Mを超えないようにアップロード処理を行う
        if (fileSizeSum > 4000000) {
          reqData.push({ bringImages: [] })
          reqDataNo++
          fileSizeSum = 0
        }

        reqData[reqDataNo].bringImages.push(imageData)
      }

      for (let reqKey = 0; reqKey < reqData.length; reqKey++) {
        // 画像アップロード処理
        const bringImageModel = await BringImageModel.apiSetStore(this.$bvModal, reqData[reqKey], () => {})
        if (!bringImageModel) {
          this.$refs.commonModal.msgBoxOk('画像のアップロードが途中で失敗しました')
          this.imageIni()
          return false
        }

        if (bringImageModel.status !== 'success' || bringImageModel.message) {
          this.$refs.commonModal.msgBoxOk(bringImageModel.message)
          this.imageIni()
          return false
        }
      }

      this.imageIni()
      this.changeBody('uploadImageComplete')
      this.$emit('signalingModalChangeEvent', 'modalUploadImageComplete')
    },
    imageIni () {
      this.overlayShow = false
      this.localImageUrl = []
      this.resizeImages = []
      this.$refs.uploadImageInput.value = ''
    },
    uploadCompleteOK () {
      this.hideModal()
      this.$emit('signalingModalChangeEvent', 'modalUploadComplateOK')
      this.floristUploaded = false
    },
    uploadImageBtnClick (possibleType) {
      if (this.attendeeType === this.consts.attendeeType[possibleType]) {
        this.$refs.uploadImageInput.click()
      }
    },
    beforeResizeImage (file, fileCount, self, i) {
      const image = new Image()
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        image.src = reader.result
        image.onload = (e) => {
          let canvasWidth = 0
          let canvasHeight = 0
          // 横幅と高さのいずれかが1280pxを超えている場合はリサイズ
          if (image.naturalWidth > 1280 || image.naturalHeight > 1280) {
            // アスペクト比計算
            const w = image.naturalWidth
            const h = image.naturalHeight
            const g = self.gcd(w, h)
            const ratioW = w / g
            const ratioH = h / g
            if (ratioW > ratioH) {
              // 横長画像(横幅 > 高さ)の場合
              canvasWidth = 1280
              canvasHeight = (1280 / ratioW) * ratioH
            } else {
              // 縦長画像(横幅 < 高さ)の場合
              canvasHeight = 1280
              canvasWidth = (1280 / ratioH) * ratioW
            }
          } else {
            canvasWidth = image.naturalWidth
            canvasHeight = image.naturalHeight
          }
          self.resizeImage(image, i, canvasWidth, canvasHeight)
          if (self.resizeCompleteCount === fileCount) {
            self.uploadBtnDisabled = false
            self.resizeCompleteCount = 0
          }
        }
      }
      self.localImageUrl.push(URL.createObjectURL(file))
    },
    cookieProjectNumberCheck: async function () {
      let currentCookieProjectNumber = ''
      let params = ['projectNumber']
      currentCookieProjectNumber = await CookieInfoModel.apiSetStore(this.$bvModal, params, () => {})
      console.log(currentCookieProjectNumber['cookieInfo'])
      console.log(this.cookieProjectNumber)
      if (currentCookieProjectNumber['cookieInfo'] === this.cookieProjectNumber) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>
#image-upload-modal .modal-header,
#image-upload-modal .modal-footer {
  display: none !important;
}
</style>
